module.exports = __webpack_public_path__ + "img/news7-2.6260e31f.png";